import axios from 'axios';

export const profileApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/profile`,
    headers: {
        'Content-Type': 'application/json'
    }
})